import { Badge, type BadgeProps } from '@frontend/components';

const defaultBadgeProps = {
  size: 'md',
  variant: 'subtle',
};

type RecordKey = string | number | symbol;

type StatusBadgeProps<T extends RecordKey> = {
  status?: T;
  propsByStatus: Record<T, Partial<BadgeProps> | null>;
  labelByStatus: Record<T, string>;
} & BadgeProps;

const StatusBadge = <T extends RecordKey>({
  status,
  propsByStatus,
  labelByStatus,
  ...rest
}: StatusBadgeProps<T>) => {
  if (status == null) {
    return null;
  }

  const propsForStatus = propsByStatus[status];

  if (propsForStatus == null) {
    return null;
  }

  const badgeProps = {
    ...defaultBadgeProps,
    ...propsForStatus,
    ...rest,
  };

  return <Badge {...badgeProps}>{labelByStatus[status]}</Badge>;
};

export default StatusBadge;
